import React, { useContext, useEffect } from "react";
import "./App.css";
import { makeStyles } from "@fluentui/react-components";
import { Header } from "./components/header/Header";
import { Message } from "./components/header/Message";
import { Content } from "./components/content/Content";
import { DataContext } from "./context/DataContext";
import { useTranslation } from "react-i18next";
import { useAuth } from "./authentication/AuthContextProvider";
import { ApiContext } from "./Root";
import { fetchInitialData } from "./helpers/defaultDataHelper";
const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
  },
});

export const App = (): JSX.Element => {
  const styles = useStyles();
  const dataContext = useContext(DataContext);
  const apiContext = useContext(ApiContext);
  const auth = useAuth();
  const { t } = useTranslation();

  useEffect(() => {
    fetchInitialData(dataContext, apiContext, auth, t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.root}>
      <Header />
      <Message />
      <Content />
    </div>
  );
};
